<template>
  <div fluid>
    <v-row>
      <v-col cols="10" style="position: relative;">
        <v-slide-group v-model="active_photo"
          class='image-thumbnails mt-4 theme-bg fa-border-radius __bubbly justify-content-center'
          loop show-arrows
          prev-icon='mdi-chevron-left' next-icon='mdi-chevron-right'>
            <v-card class="w-100 pa-2 justify-content-center"
              style="display: inline-flex;">
                <v-slide-item v-for="(photo_x, i) in photos"
                  :key="i" v-slot:default="{ active }">
                    <v-card
                      :outlined="!active"
                      :raised="active"
                      class="ma-2 ml-lg-5 d-flex justify-center align-center"
                      height='90' width='90'
                      @click="active_photo=i; calculatePhotoDetails">
                        <v-img :src="photo_x?.image_url" aspect-ratio="1"></v-img>
                    </v-card>
                </v-slide-item>
            </v-card>
        </v-slide-group>


        <v-img
          ref="image"
          :src="photos[active_photo]?.image_url"
          @load="calculatePhotoDetails"
          @click="postCoordinate" @resize="calculatePhotoDetails">
          <template v-if="photo_details.naturalHeight > 0">
            <div
                v-for="(coord, index) in photos[active_photo]?.coordinates"
                :key="index"
                class="circle"
                :style="calculateCoordinateStyles(coord)"
                @click.stop="donothing"
              >

              <v-tooltip bottom>
                <template v-slot:activator='{ on, attrs }'>
                    <span v-bind='attrs' v-on='on'>
                        <span v-if="!markup_mode" v-on='on' style="cursor:pointer" @click.stop="removeCoordinate(coord)">
                          <span class='material-symbols-outlined' style="cursor:pointer; font-size: 14px">delete</span>
                        </span>
                    </span>
                </template>
                <span>Delete Tag</span>
              </v-tooltip>
            </div>
          </template>
        </v-img>

				<v-container class="">
					<v-btn
						class="mr-2 float-left"
						color="success"
						@click="skipPhoto(photos[active_photo])"
					>Ignore This Image
					</v-btn>
					<v-btn
						class="mr-2 float-right"
						color="primary"
						@click="submitPhotos(photos)"
					>Submit Photos
					</v-btn>
				</v-container>
			</v-col>
			<v-col cols="2">
				<div v-if="photos[active_photo]" style="text-align:left;margin-bottom:20px;">
          <div><b>Project Name: </b>{{ photos[active_photo].project_name }}</div>
          <div><b>Job Name: </b>{{ photos[active_photo].job_name }}</div>
					<div><b>Response Group ID: </b>{{ photos[active_photo].response_group_id }}</div>
					<div><b>Question ID: </b>{{ photos[active_photo].question_id }}</div>
					<div><b>Response ID: </b>{{ photos[active_photo].response_id }}</div>
				</div>
				<div style="position: -webkit-sticky; position: sticky; top: 55px">
					<h4>Markup Mode</h4>
					<v-radio-group v-model="markup_mode">
						<v-radio v-for="tag in tags" :key="tag.id" :value="tag.id" :color="coordinate_colors[tag.id]" :base-color="coordinate_colors[tag.id]">
              <template #label>
                <span style="display: inline-flex; align-items: center; gap: 8px;">

                  <span>{{ tag.name }} {{ tag_count(tag.id) }}</span>
                  <span
                    :style="{
                      width: '14px',
                      height: '14px',
                      backgroundColor: coordinate_colors[tag.id],
                      flexShrink: 0,
                      display: 'inline-block'
                    }"
                  ></span>
                </span>
              </template>

            </v-radio>
					</v-radio-group>
					<v-container>
						<v-tooltip bottom>
							<template v-slot:activator='{ on, attrs }'>
                <span v-bind='attrs' v-on='on'>
                    <v-btn
                      color="error"
                      @click="markup_mode = ''">
                      Remove Tags
                    </v-btn>
                </span>
							</template>
							<span>Remove Tags</span>
						</v-tooltip>
					</v-container>
          <p>Pinch to Zoom on Mac or Ctrl + scroll on Windows</p>
				</div>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import axios from "axios";
// import InnerImageZoom from "vue-inner-image-zoom";

export default {
	name: "energizerPhotoTagging",
	components: {
		// InnerImageZoom
	},
	data() {
		return {
			photos: [],
			active_photo: -1,
			photo_details: {
				clientWidth: 0,
				clientHeight: 0,
				naturalWidth: 0,
				naturalHeight: 0,
				calculatedAspectRatio: 0
			},
			isMounted: false,
			markup_mode: "",
			coordinates: [],
			coordinate_colors: [
				"#0E34A0",
				"#0E34A0",
				"#A5BE00",
				"#FE654F",
				"#5CC8FF",
				"#A6F4DC",
				"#FFC914",
				"#E4572E",
				"#6A7FDB",
				"#E3170A"
			]
		}
	},
	methods: {
		getPhotos() {
      const response_id = this.$route.query.response_id;
      let url = '/api/photo/';
      if (response_id) {
        url = `/api/photo/?response_id=${response_id}`;
      }
			return axios.get(url)
				.then(response => {
					this.photos = response.data;
					this.active_photo = 0;
					this.calculatePhotoDetails()
				})
				.catch(e => {
					console.log(e)
				})
		},
		submitPhotos() {
			// submit photos
			return axios.post('/api/photo/', {photos: this.photos})
				.then(response => {
					if (response.status === 200) {
						this.getPhotos();
					}
				})
				.catch(e => {
					console.log(e)
				})
		},
		skipPhoto(photo) {
			// skip photo
			return axios.post('/api/photo/skip/', {photo: photo})
				.then(response => {
					const index = this.photos.indexOf(photo);
					if (index > -1) {
						this.photos.splice(index, 1);
						this.active_photo = 0;
					}
				})
				.catch(e => {
					console.log(e)
				})
		},
		coordinateTooClose(newx, newy){
			let min_distance = 18; // this needs to be the same as the width of the dots on the screen
			let coordinates = this.photos[this.active_photo].coordinates;
			for (let i=0; i<coordinates.length;i++){
				let coordinate = coordinates[i];
				let distance = Math.sqrt(Math.pow(coordinate.x_pixel - newx, 2) + Math.pow(coordinate.y_pixel - newy, 2));
				if (distance < min_distance){
					return true;
				}
			}
			return false;
		},
		donothing(){
			return
		},
		postCoordinate(event) {
			if (!this.markup_mode) {
				return;
			}
			const rect = event.target.getBoundingClientRect();
			const x_padding = (rect.width - this.photo_details.calculatedAspectRatio * rect.height) / 2;
			const x = event.clientX - rect.left - x_padding;
			const x_percent = x / rect.width;
			const natural_x = this.photo_details.naturalWidth * x_percent;
			const y = event.clientY - rect.top;
			const y_percent = y / rect.height;
			const natural_y = this.photo_details.naturalHeight * y_percent;

			if (this.coordinateTooClose(natural_x, natural_y)){
				alert("That point is too close to the other points");
				return;
			}
			let post_data = {
				x: natural_x,
				y: natural_y,
				photo_id: this.photos[this.active_photo].id,
				tag_id: this.markup_mode
			}
			return axios.post('/api/coordinate/', post_data)
				.then(response => {
					this.photos[this.active_photo].coordinates.push(response.data);
				})
				.catch(e => {
					console.log(e)
				})

		},
		removeCoordinate(coordinate) {
			// remove from coordinates
			return axios.delete(`/api/coordinate/${coordinate.id}`)
				.then(response => {
					this.photos[this.active_photo].coordinates = this.photos[this.active_photo].coordinates.filter(coord => coord !== coordinate);
				})
				.catch(e => {
					console.log(e)
				})
		},
		async calculatePhotoDetails() {
			const img = new Image();
			img.src = this.photos[this.active_photo]?.image_url;
			await new Promise((resolve) => {
				img.onload = resolve;
			});
			this.photo_details.naturalWidth = img.naturalWidth;
			this.photo_details.naturalHeight = img.naturalHeight;
			this.photo_details.calculatedAspectRatio = img.naturalWidth / img.naturalHeight;
			this.photo_details.clientHeight = this.$refs.image.$el.clientHeight;
			this.photo_details.clientWidth = this.$refs.image.$el.clientWidth;
		},
    calculateCoordinateStyles(coord) {
      const top = `${coord.y_pixel * (this.photo_details.clientHeight / this.photo_details.naturalHeight)}px`;
      const left = `${coord.x_pixel * (this.photo_details.clientWidth / this.photo_details.naturalWidth)}px`;
      return {'top': top, 'left': left, 'backgroundColor': this.coordinate_colors[coord.tag]};
    },
    tag_count(tag_id){
      let count = 0;
      for (let i=0; i<this.photos[this.active_photo].coordinates.length; i++){
        if (this.photos[this.active_photo].coordinates[i].tag === tag_id){
          count++;
        }
      }
      return ` (${count})`;
    }
	},
	created() {
  		window.addEventListener("resize", this.calculatePhotoDetails);
	},
	destroyed() {
		window.removeEventListener("resize", this.calculatePhotoDetails);
	},
	mounted() {
		this.isMounted = true;
		this.getPhotos();
	},
	watch: {
		active_photo: function(new_val, prev_val){
			if (new_val !== prev_val) {
				this.calculatePhotoDetails();
			}
		}
	},
	computed: {
		...mapState({
			tags: state => state.tags.tags,
		}),
	},
}
</script>

<style scoped>


.circle {
	position: absolute;
	width: 18px;
	height: 18px;
	border-radius: 50%;
  opacity: .75;
	transform: translate(-50%, -50%);
}
</style>